import { useEffect } from "react";
import {
  useDeleteUserMutation,
  useGetUsersMutation,
} from "../../store/services/authApi";
import { MdDelete } from "react-icons/md";
import Modal from "../../components/Modal";
import { useState } from "react";
import { useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const UsersList = () => {
  const navigate = useNavigate();

  const toast = useToast();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState(null);

  const [getUsers, { data, isSuccess, isError, error }] = useGetUsersMutation();
  const [
    deleteUser,
    {
      data: dataDeleteUser,
      isSuccess: isSuccessDeleteUser,
      isError: isErrorDeleteUser,
      error: errorDeleteUser,
    },
  ] = useDeleteUserMutation();

  useEffect(() => {
    getUsers("");
  }, []);

  useEffect(() => {
    if (isSuccessDeleteUser) {
      toast({
        title: "User Deleted Successfully!",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      getUsers();
      setDeleteUserId(null);
      setDeleteModal(false);
    }
    if (isErrorDeleteUser) {
      toast({
        title: "Error Deleting User!",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      getUsers();
      setDeleteUserId(null);
      setDeleteModal(false);
    }
  }, [isSuccessDeleteUser, isErrorDeleteUser]);

  //   useEffect(() => {
  //     console.log("data", data, isSucess, isError, error);
  //   }, [data, isSucess, isError]);

  return (
    <main className="w-full bg-white flex-col flex p-10">
      <div className="filters w-full relative my-2 mb-10 flex justify-between items-center">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">Users</h1>
        </div>
        <div className="flex items-center justify-between">
          <button
            onClick={() => {
              console.log("create user clicked");
              navigate("/CreateUser");
            }}
            className="bg-black text-white rounded-lg px-4 py-2 w-full"
          >
            Create User
          </button>
        </div>
      </div>
      <table className="border-collapse rounded-xl overflow-hidden">
        <tbody>
          {/* <th> */}
          <tr className="bg-black divide-x text-white  border ">
            <th className="py-2">Name</th>
            <th>Email ID</th>
            <th>Actions</th>
          </tr>
          {/* </th> */}
          {data &&
            isSuccess &&
            data.length > 0 &&
            data.map((val) => {
              return (
                <tr
                  key={val._id}
                  className="text-center border-t border-gray-200 divide-x "
                >
                  <td className="py-1">{val.name}</td>
                  <td>{val.email}</td>
                  <td>
                    <div
                      onClick={() => {
                        console.log("clicked");
                        setDeleteModal(true);
                        setDeleteUserId(val.user_id);
                      }}
                      className="flex items-center justify-center text-lg gap-1 cursor-pointer"
                    >
                      <MdDelete />
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>

      {deleteModal && (
        <Modal
          onClose={() => {
            console.log("here");
            setDeleteModal(false);
            setDeleteUserId(null);
          }}
        >
          <div>
            <h4 className="text-lg font-medium mb-3 text-cneter">
              Are you sure you want to delete the selected user?
            </h4>
            <div className="flex gap-4">
              <button
                onClick={() => {
                  console.log("yes clicked", deleteUserId);
                  deleteUser(deleteUserId);
                }}
                className="bg-black text-white rounded-lg px-4 py-2 w-full"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setDeleteModal(false);
                  setDeleteUserId(null);
                  console.log("no clicked");
                }}
                className="border border-black rounded-lg px-4 py-2 w-full"
              >
                No
              </button>
            </div>
          </div>
        </Modal>
      )}
    </main>
  );
};

export default UsersList;
